/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the activation mode to use for the grid.
 */
export var GridActivationMode = /*@__PURE__*/ (function (GridActivationMode) {
    /**
     * No activation should be peformed based on interaction.
     */
    GridActivationMode[GridActivationMode["None"] = 0] = "None";
    /**
     * A single cell is permitted to be activated at a time.
     */
    GridActivationMode[GridActivationMode["Cell"] = 1] = "Cell";
    return GridActivationMode;
})({});
/**
 * @hidden
 */
export var GridActivationMode_$type = /*@__PURE__*/ markEnum('GridActivationMode', 'None,0|Cell,1');
//# sourceMappingURL=GridActivationMode.js.map
